import { render, staticRenderFns } from "./pieRing.vue?vue&type=template&id=3b78c382&"
import script from "./pieRing.vue?vue&type=script&lang=js&"
export * from "./pieRing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pieRing.vue"
export default component.exports